// extracted by mini-css-extract-plugin
export default {"hay":"styles_hay__O5G37"};